import { Box, Grid } from '@mui/material';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import { useWorkspaceContext } from '../../../context';
import {
  emailRules,
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../teams/helper/defaultValues';

const EmailsSettings = ({ title, description, emailPrefix, pageType }) => {
  const loggedInWorkspace = useWorkspaceContext();
  const workspaceName = loggedInWorkspace.link;

  return (
    <SettingsPageLayout
      title={title}
      indexOptions={[{ label: title, url: '' }]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages[pageType]
      )}
    >
      <Grid container p={5} rowSpacing={4}>
        <Grid item xs={12}>
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            {title}
          </WsTypography>
        </Grid>
        <Grid item>
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.QUATERNARY}>
            {description}
          </WsTypography>
        </Grid>
        <Grid item>
          <Box
            borderColor={WsColors.TertiaryShades200}
            p={1}
            borderRadius={2}
            border={`2px solid ${WsColors.Gray88}`}
          >
            <WsTypography variant={WsTypoVariants.BODY1}>
              {`${workspaceName}.${emailPrefix}@resumes.wisestep.com`}
            </WsTypography>
          </Box>
        </Grid>
        <Grid item>
          <WsTypography variant={WsTypoVariants.BODY1} bold>
            {`Pro Tip: Set up an email forwarding filter in your inbox, e.g., from:
            ${workspaceName}.${emailPrefix}@resumes.wisestep.com, to automate the process further.`}
          </WsTypography>
        </Grid>
        <Grid item xs={12}>
          <WsTypography variant={WsTypoVariants.BODY1} bold>
            Guidelines :
          </WsTypography>
        </Grid>
        <Grid item>
          {emailRules.map((rule, index) => (
            <WsTypography key={index} variant={WsTypoVariants.BODY1}>
              {rule}
            </WsTypography>
          ))}
        </Grid>
      </Grid>
    </SettingsPageLayout>
  );
};

export default EmailsSettings;
